// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  var sectionObjectUrl = $section.find('[data-theme-editor-load-script]').attr('src');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];

      // Check to see if section script exists
      if (typeof Shopify.theme[triggerClass] == 'undefined') {
        // make AJAX call to load script
        Shopify.theme.loadScript(triggerClass, sectionObjectUrl, function () {
          Shopify.theme[triggerClass].init($(section));
        });
      } else {
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(section));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          var $block = $('.'+ triggerClass)
          var blockUrl = $block.find('[data-theme-editor-load-script]').attr('src');

          // Check to see if section script exists
          if (typeof Shopify.theme[triggerClass] == 'undefined') {
            // make AJAX call to load script
            Shopify.theme.loadScript(triggerClass, blockUrl, function () {
              Shopify.theme[triggerClass].init($block);
            });
          } else {
            if (Shopify.theme[triggerClass]) {
              // console.log('Block: ' + triggerClass + ' has been loaded.')
              Shopify.theme[triggerClass].init($(this));
            } else {
              // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
            }
          }

        }
      }
    });
  }

  // Load video feature
  Shopify.theme.video.init();

  // Scrolling animations
  Shopify.theme.animation.init();

  // Initialize reviews
  Shopify.theme.productReviews.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Infinite scrolling
  Shopify.theme.infiniteScroll.init();

  // Disclosure menus
  Shopify.theme.disclosure.enable();

  // Search
  $(document).on('click',  '[data-show-search-trigger]', function(){
    Shopify.theme.jsHeader.showSearch();
  });

  $('.search-overlay__close').on('click', function(){
    Shopify.theme.jsHeader.hideSearch();
  });

  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }
  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  var $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsMap)
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        // console.log('Section: ' + triggerClass + ' is unloaded.')
        Shopify.theme[triggerClass].unload($(section));
      } else {
        // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
      }
    }
  }

  // Check classes on block element and look for js (eg. jsMap)
  if ($jsSectionBlocks.length > 0) {
    var $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          var triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            // console.log('Block: ' + triggerClass + ' is unloaded.')
            Shopify.theme[triggerClass].unload($(this));
          } else {
            // console.warn('Uh oh, ' + triggerClass + ' is referenced in block class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.unload() function exists.');
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

  // QuantityBox
  Shopify.theme.quantityBox.unload($section);

  // Infinite scrolling
  Shopify.theme.infiniteScroll.unload($section);

  // Disclosure menus
  Shopify.theme.disclosure.enable();

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  if(isScreenSizeLarge() && Shopify.theme.jsHeader.enable_overlay === true) {
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

  if ($('.block__recommended-products').length > 0) {
    var $productPage = $('.block__recommended-products').parents('.product-page');
    Shopify.theme.jsRecommendedProducts.init($productPage);
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  var $section = $(e.target);

  // Vanilla js selection of Shopify section
  var section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (var i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      var triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  var $block = $('#shopify-section-' + blockId);

  if($('.jsFeaturedPromos').length > 0) {
    Shopify.theme.jsFeaturedPromos.blockSelect($parentSection, blockId);
  }

  if($('.jsSlideshowWithText').length > 0) {
    Shopify.theme.jsSlideshowWithText.blockSelect($parentSection, blockId);
  }

  if ($('.jsSlideshowClassic').length > 0) {
    Shopify.theme.jsSlideshowClassic.blockSelect($parentSection, blockId);
  }

  if($('.jsTestimonials').length > 0) {
    Shopify.theme.jsTestimonials.blockSelect($parentSection, blockId);
  }

  // Sidebar collection multi-tag filter
  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="closed"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
    }
  }

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

});

$(document)
.on('shopify:block:deselect', function(e){

  var $block = $('#shopify-section-' + e.detail.blockId);

  if ($block.hasClass('sidebar__block')) {
    var $toggleBtn = $block.find('[data-sidebar-block__toggle="open"]');
    if ($toggleBtn) {
      Shopify.theme.jsSidebar.closeSidebarBlock($toggleBtn);
    }
  }

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  var $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  var $jsSectionNames = $jsSections.each(function () {
    for (var i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        var triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          // console.log('Section: ' + triggerClass + ' has been loaded.')
          Shopify.theme[triggerClass].init($(this));
        } else {
          // console.warn('Uh oh, ' + triggerClass + ' is referenced in section schema class, but can not be found. Make sure "z__' + triggerClass + '.js" and Shopify.theme.' + triggerClass + '.init() function exists.');
        }

      }
    }
  });

  var resizeTimer;

  // Store window width in variable
  var width = $(window).width(), height = $(window).height();

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      Shopify.theme.objectFitImages.calculateAspectRatio();

      if (Shopify.theme.jsHeader.header_layout === 'vertical') {
        Shopify.theme.predictiveSearch.alignVerticalSearch()
      }

      if (!isScreenSizeLarge()){
        // When 798 or less
        Shopify.theme.mobileMenu.init();

      } else {

        // When larger than 798
        Shopify.theme.mobileMenu.unload();

        // Swatches
        if(Shopify.theme_settings.product_form_style == 'swatches') {
          Shopify.theme.thumbnail.enableSwatches();
        }
      }

    }, 250);

  });

  //Enable plyr
  Shopify.theme.video.init();

  // Predictive search
  if (Shopify.theme_settings.enable_autocomplete == true) {
    Shopify.theme.predictiveSearch.init();
  }

  Shopify.theme.dropdownMenu();

  Shopify.theme.disclosure.enable();

  // Scrolling animations
  Shopify.theme.animation.init();

  // QuantityBox
  Shopify.theme.quantityBox.init();

  /* Show secondary image on hover */
  if (Shopify.theme_settings.show_secondary_image == true) {
    Shopify.theme.thumbnail.showVariantImage();
  }

  // Collection swatches
  if (Shopify.theme_settings.show_collection_swatches) {
    Shopify.theme.thumbnail.enableSwatches();
  }

  // Quick shop
  if (Shopify.theme_settings.enable_quickshop) {
    Shopify.theme.thumbnail.showQuickShop();
  }

  // Currency converter
  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    Shopify.theme.currencyConverter.init();
  }

  //Infinite scrolling
  if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
  }

  //Select event for native multi currency checkout
  $('.shopify-currency-form select').on('change', function () {
    $(this)
      .parents('form')
      .submit();
  });

  // Tabs
  if($('.tabs').length > 0) {
    Shopify.theme.tabs.enableTabs();
  }

  // Additional checkout buttons
  if (!isScreenSizeLarge()) {
    $('.additional-checkout-buttons').addClass('additional-checkout-buttons--vertical');
  }

  // Accordion
  if($('.accordion, [data-cc-accordion]').length > 0) {
    Shopify.contentCreator.accordion.init();
  }

  // Backwards compatiblity for Flexslider
  if($('.slider, .flexslider').length > 0) {
    Shopify.contentCreator.slideshow.init();
  }

  // Object Fit Images
  Shopify.theme.objectFitImages.init();

  // Responsive Video
  Shopify.theme.responsiveVideo.init();

  // Flickity IOS Fix
  Shopify.theme.flickityIosFix();

  // Product review scroll
  Shopify.theme.productReviews.productReviewScroll();
  
  
/** START -  CUSTOM JS CODES **/
  

  $('.quick_shop_trigger').click(function(){
	var target = $(this).data("target");
    $('span.'+target).click();
  });

  $("a.buy-qucik-shop, #bogo_confirm").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
		'overlayShow'	:	false
	});
  $(".blog-testimonial__image .image > a, .blog-testimonials-section .blog-card__read-more > a, .blog-testimonials-section .card-content.blog-card__content .title > a").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
		'width':'80%',
         helpers: {
          overlay: {
            locked: false
          }
         }
	});
  $(".blog-testimonials-section, .section-video-items").on("focusin", function(){ 
   $(".blog-testimonial__image .image > a, .blog-testimonials-section .blog-card__read-more > a, .blog-testimonials-section .card-content.blog-card__content .title > a").fancybox({
    	'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
		'width':'80%',
         helpers: {
          overlay: {
            locked: false
          }
         }
   }); 
  });
  $(document).on('click','.blog-testimonials-section .excerpt *',function(){ 
  	 $(this).parents('.featured-article').find('.blog-card__read-more.buttons a').click();
  });
  
  $('a.parent-anchor').click(function(evt){
    //evt.preventDefault();
    $('.parent-link').removeClass('active');
    $('.nav-menus, .footer-all-menu, .nav-logo').removeClass('active');
    var target = $(this).data('target');
    $(this).parents('.parent-link').addClass('active');
    $('.'+target+'-menu, .footer-all-menu.'+target+', .'+target+'-logo').addClass('active');
    
    var footer_menu_parent = $('.footer-nav.'+target).parents('.footer__block');
    //var count = $(footer_menu_parent).children().length;
    $(footer_menu_parent).children('.active').removeClass('active');
    $('.footer-nav.'+target).addClass('active');
    //$('.'+target+'-menu a.header__logo, a.mobile-header__logo').attr('href',$(this).attr('href'));
//     $('.footer__container .footer__menu .footer__menu-link > a').each(function(){
//     	var init_href = $(this).attr('href');
//         if(init_href.indexOf("human") >= 0 || init_href.indexOf("canine") >= 0 || init_href.indexOf("equine") >= 0){
//           var replaced = init_href.replace('human', target).replace('canine', target).replace('equine', target);
//           $(this).attr('href',replaced);
//         }
//     });
    
  });
  
  var suffix = $('body.site-body').attr('data-template');
  var all_url = window.location.pathname; 
  //suffix.toLowerCase().indexOf("natura") >= 0 || 
  if(all_url.toLowerCase().indexOf("natura-") >= 0 || all_url.toLowerCase().indexOf("natural-siberica") >= 0 || all_url.toLowerCase().indexOf("/ns-") >= 0){
    //$('a.parent-anchor.natura').parents('.parent-link').addClass('active'); 
    $('a.parent-anchor.natura').click(); 
  }else if(all_url.toLowerCase().indexOf("planeta-") >= 0 || all_url.toLowerCase().indexOf("planeta-organica") >= 0 || all_url.toLowerCase().indexOf("/po-") >= 0) {
    $('a.parent-anchor.planeta').click();   
    
  }else if(all_url.toLowerCase().indexOf("organic-shop-") >= 0 || all_url.toLowerCase().indexOf("organic-shop") >= 0 || all_url.toLowerCase().indexOf("/os-") >= 0){
    $('a.parent-anchor.organic').click(); 
    
  }

  if(getCookie('discount_code') != ""){
    Cookies.set('popup', 'opened', {expires: 2});
    
    $('div.tag.'+getCookie('discount_code')).css('background','#337ab7').find('a.discount-tag-anchor').css('color','#FFF');
    var discBlob = $('#discount-array-div').val();
    var codeCookieValue = getCookie('discount_code');
    //     console.log("Disc aray: "+discBlob);
	    var discDict = {};
    	var discType = {};
        var	discArr = discBlob.split(",");
        for (let i = 0; i < discArr.length; i++) {
            var thisRow = discArr[i] ;
            var thisRowBits = thisRow.split("|");
     //     console.log(thisRowBits[1]);
            discDict[thisRowBits[1]] = thisRowBits[2];    
			discType[thisRowBits[1]] = thisRowBits[0];
        }
        var myDisc = discDict[codeCookieValue];
        var discountType = discType[codeCookieValue];
    	
        var isBogoDiscount = false;
    	var discount_msg = myDisc+'% DISCOUNT APPLIED';
    	if(discountType == "bogo" || discountType == "BOGO"){
        	discount_msg = 'BUY 1 GET 1 FREE';
            isBogoDiscount = true;
        }
        discountedPrice(myDisc,discount_msg);
    
        var $el = $('[data-ajax-cart-trigger]');
        $el.hover(function () {
            if(getCookie('discount_code') != ""){
                $('.theme-ajax-cart .discounter-money, .theme-ajax-cart .discounted-label, .theme-ajax-cart .money br').remove();
                $('.theme-ajax-cart .money').each(function(){
                        var init_price = $(this).text();
                        var oldPriceVal =  init_price.replace("$", "").replace(",", "").replace(" ", "").replace(/[^\d.-]/g, '');
                        var newPrice = (oldPriceVal *(1-(myDisc/100))).toFixed(2);
                        $(this).css({
                          'display':'inline-block',
                          'text-decoration':'line-through'
                        }).append('<span class="money discounter-money">$'+newPrice+'</span><br/><span class="discounted-label">'+discount_msg+'</span>');
                });
            
            }
          }, function () {
          		$('.theme-ajax-cart .money').css('text-decoration','none');
          		$('.theme-ajax-cart .discounted-label').remove();
          		$('.theme-ajax-cart .discounter-money').each(function(){
                	$(this).remove();
                }); 
          });
          $(document).on('change','.theme-ajax-cart .quantity-input',function(){
            $('.theme-ajax-cart .discounter-money').remove();
            if(getCookie('discount_code') != ""){
              setTimeout(function(){
                $('.theme-ajax-cart .discounter-money, .theme-ajax-cart .discounted-label, .theme-ajax-cart .money br').remove();
              	$('.theme-ajax-cart .money').each(function(){
                        var init_price = $(this).text();
                        var oldPriceVal =  init_price.replace("$", "").replace(",", "").replace(" ", "").replace(/[^\d.-]/g, '');
                        var newPrice = (oldPriceVal *(1-(myDisc/100))).toFixed(2);
                        $(this).css({
                          'display':'inline-block',
                          'text-decoration':'line-through'
                        }).append('<span class="money discounter-money">$'+newPrice+'</span><br/><span class="discounted-label">'+discount_msg+'</span>');
                });
              }, 1500);
            }
          });
    	  $(document).on('click','.theme-ajax-cart .quantity-wrapper span.quantity-element',function(){
          	  setTimeout(function(){
                $('.theme-ajax-cart .discounter-money, .theme-ajax-cart .discounted-label, .theme-ajax-cart .money br').remove();
              	$('.theme-ajax-cart .money').each(function(){
                        var init_price = $(this).text();
                        var oldPriceVal =  init_price.replace("$", "").replace(",", "").replace(" ", "").replace(/[^\d.-]/g, '');
                        var newPrice = (oldPriceVal *(1-(myDisc/100))).toFixed(2);
                        $(this).css({
                          'display':'inline-block',
                          'text-decoration':'line-through'
                        }).append('<span class="money discounter-money">$'+newPrice+'</span><br/><span class="discounted-label">'+discount_msg+'</span>');
                });
              }, 1500);
          });
    
        if(discountType == "bogo" || discountType == "BOGO"){
          
          bogoDiscount(); 
          
          window.onload = function() {
                $('.bogo-qty').each(function(){
                   var init_val = $(this).val();
                    if(init_val == "" || init_val == undefined){
                    	init_val = 1;
                    }
                   $(this).val(init_val * 2);
                });
		  }
          
          $('.theme-ajax-cart .quantity-input, .cart__item-list .quantity-input').each(function(){
          	 
          });
//           $(document).on('focusin','.quantity-input', function(){ 
//               $(this).data('val', $(this).val());
                                                                 
//           });
          
          $(document).on('change','.quantity-input',function(){ 
            
//             var init_val = $(this).val(); console.log(init_val);
//             var prev = $(this).data('val');
//             if (init_val % 2 !== 0) {
//                 if (!confirm('You are in Buy 1 Get Free Discount! You will lose this discount if you add or deduct a quantity.\nWould you like to continue?')) {
//                     $(this).val(prev);
//                     return false;
//                 }     
//             }
            //$.data(this, 'current', $(this).val());
            
          });
          
          	
          }else{
            //setCookie('BOGO_IMPLEMENTED','false', 7);
          }
    	
  }
  
  $('a.discount-tag-anchor').click(function(){
	 //      event.preventDefault();
     var redirec_url = $(this).data('redirect');
     var url = $(this).data('href');
     $.ajax({
         url: url,
         contentType: "application/json",
         dataType: 'json',
         success: function(result){ 
            console.log(result);
            //window.location.href= redirec_url;
         }
     });
     setTimeout(function(){window.location.href= redirec_url;}, 1000);
  });
  
  function discountedPrice(myDisc, discount_msg){
    setTimeout(function(){
    	$('.product-wrap .money .money, .cart__form .money').each(function(){
                var init_price = $(this).text();
                var oldPriceVal =  init_price.replace("$", "").replace(",", "").replace(" ", "").replace(/[^\d.-]/g, '');
                var newPrice = (oldPriceVal *(1-(myDisc/100))).toFixed(2);
          		if(init_price.toLowerCase().indexOf("usd") >= 0){
                	var init_money = init_price.trim().split(" ");
                  	$(this).html(init_money[0]+' '+'<strike>'+init_money[1]+'</strike>').css({
                      'display':'inline-block',
                      'text-decoration':'none'
                    }).after('<span class="money discounter-money">$'+newPrice+'</span><span class="discounted-label">'+discount_msg+'</span>');
                  	
                }else{ 
                	$(this).css({
                      'display':'inline-block',
                      'text-decoration':'line-through'
                    }).after('<span class="money discounter-money">$'+newPrice+'</span><span class="discounted-label">'+discount_msg+'</span>');
                }
          		
        });
    }, 1300);
  }
  function bogoDiscount(){
    setTimeout(function(){
        $('#rhv-new-price').html('BUY 1 GET 1 FREE');
        $('.product-wrap .discounter-money, .cart__info .discounter-money, .product-wrap .discounted-label').remove();
    	$('.product-wrap .money .money, .cart__info .money').each(function(){
                //var init_price = $(this).text();
                //var oldPriceVal =  init_price.replace("$", "").replace(",", "").replace(" ", "").replace(/[^\d.-]/g, '');
                //var newPrice = (oldPriceVal *(1-(myDisc/100))).toFixed(2);
          		$(this).css({
                  'display':'block',
                  'text-decoration':'none'
                }).after('<span class="money discounter-money">BUY 1 GET 1 FREE</span>');
        });
    }, 1300);
  }

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function BOGOConfirm(val){
    var txt;
    var r = confirm("You are in Buy 1 Get Free Discount! You will lose this discount if you add or deduct a quantity\nWould you like to continue?");
    if (r == true) {
      txt = "You pressed OK!";
    } else {
      txt = "You pressed Cancel!";
    }
    
  }
$(document).ready(function(){
 Shopify.theme.articleSearch.init();
});

Shopify.theme.articleSearch = {
  init: function init() {
      $("[data-blog-only] form").on("submit", function (e) {
        e.preventDefault();
        var $this = $(this);
        var formValue = $(this).find('input[name="q"]').val();
        var cleanFormValue = encodeURI(formValue);
        var searchType = Shopify.theme_settings.search_option;

        if ($(this).find('[name="type"]').length > 0) {
          searchType = $(this).find('[name="type"]').val();
        }
        
        if ($.trim(formValue.toLowerCase()) == null || $.trim(formValue.toLowerCase()) == "") { 
            var url = window.location.href;
            window.location.href = url;
            
        }else{
        	Shopify.theme.articleSearch.getResults(formValue, $this);
        }
    });
  },
  getResults: function getResults(term, $this) {
    var searchType = Shopify.theme_settings.search_option;

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": Shopify.theme_settings.search_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,vendor,product_type,tag"
        }
      }
    }).done(function (response) {
      var suggestions = [response.resources.results.articles];
      var filteredResults = []; // Store results in array

      $.each(suggestions, function (index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) {
          // Ensure suggestion exists
          filteredResults.push(suggestion);
        }
      }); // Display results
	  
      Shopify.theme.articleSearch.displayResults(filteredResults[0], $this);
//       Shopify.theme.predictiveSearch.vars.displayTimer = setTimeout(function () {
//         Shopify.theme.predictiveSearch.displayResults(filteredResults[0], $this);
//       }, 500);
    });
  },
  displayResults: function displayResults(results, $this) { 
    $('[data-custom-pagination]').hide();
    $('#no_results').hide();
    var $writtenBlog = $('.blog-testimonials-section > [data-load-more--grid]');
    var $videoBlog = $('.section-video-items > [data-load-video-article]');
    $writtenBlog.parent('.section').hide();
    $videoBlog.parent('.section').hide();
    $videoBlog.find('.featured-article').remove();
    $writtenBlog.find('.featured-article').remove();                                                       
                                                           
    var $resultsList = $this.find('.search__results');
    var searchType = Shopify.theme_settings.search_option;
    //$resultsWrapper.show();
    //$resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    if (results && results.length > 0) {
      $.each(results, function (index, result) { 
        var $BlogContainer = $('.blog-testimonials-section > [data-load-more--grid]');
        if($.inArray("testimonial-video", result['tags']) !== -1 || $.inArray("video", result['tags']) !== -1 || $.inArray("Testimonial-video", result['tags']) !== -1){
        	$BlogContainer = $('.section-video-items > [data-load-video-article]');
            var $vidColumn = $("<div>", {class: "featured-article blog-card one-fourth columns article card show-border- medium-down--one-half small-down--one-whole has-margin-bottom ", "data-tags":""});
            var $vidBlogCardImage = $("<div>",{class:"card-image blog-card__image blog-testimonial__image"});
            var $vidFigure = $("<figure>",{class:"image"});   
            var $vidAnchor = $("<a>",{tabindex:"1", href:"#blog_article_"+result['id'], "data-href":result['url'], title:result['title']}); 
            var $vidImageElementWrap = $("<div>",{class:"image-element__wrap"}); 
            var $vidImage = $("<img>",{class:"transition--fade-in lazyautosizes lazyloaded", alt:result['title'], src:result['featured_image']['url']});                                                        
            
            var $vidBlogArticleOverlayContainer = $('<div class="blog-article-overlay-container"><div class="card-content blog-card__content"><div class="media"><div class="media-content"><button type="button" class="plyr__control plyr__control--overlaid plyr__tab-focus" aria-label="Play" data-plyr="play"> <svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"></path></svg> <span class="plyr__sr-only">Play</span></button></div></div></div></div>');

        	var $vidFancyContainer = $('<div style="display:none"><div id="blog_article_'+result['id']+'" class="blog-popup-container"> <div class="article-title"> <h4 class="title">'+result['title']+'</h4></div> <div class="article-content">'+result['body']+'</div></div></div>');
            
            $($vidImageElementWrap).append($vidImage);
            $($vidAnchor).append($vidImageElementWrap);
            $($vidFigure).append($vidAnchor);
            $($vidBlogCardImage).append($vidFigure);
            $($vidColumn).append($vidBlogCardImage);
            $($vidColumn).append($vidBlogArticleOverlayContainer);
            $($vidColumn).append($vidFancyContainer);
            $($BlogContainer).append($vidColumn);
            $videoBlog.parent('.section').show();
        
        }else{
        	var $column = $("<div>", {"data-load-more--grid-item": "", class: "featured-article blog-card one-fifth columns article card show-border-false medium-down--one-half small-down--one-whole has-margin-bottom", "data-tags":""});
            var $testimonial__name = $("<div>",{class:"testimonial__name blog-testimonial__image"});
            var $blogCardImage = $("<div>",{class:"card-image blog-card__image"});
            var $figure = $("<figure>",{class:"image"});     
            var $anchor = $("<a>",{tabindex:"1", href:"#blog_article_"+result['id'], "data-href":result['url'], title:result['title']}); 
            var $testimonial__image = $("<div>",{class:"testimonial__image has-image-crop image-style--circle"}); 
            var $imageElementWrap = $("<div>",{class:"image-element__wrap"}); 
            var $image = $("<img>",{class:"transition--fade-in lazyautosizes lazyloaded", alt:result['title'], src:result['featured_image']['url']});                                                        

            var $blogArticleOverlayContainer = $('<div class="blog-article-overlay-container"><div class="card-content blog-card__content"><div style="max-height: inherit;" class="excerpt excerpt-length-lg has-margin-bottom"><p style="text-align: left;">'+result['summary_html']+'</p></div><div class="media"><div class="media-content"> <h4 class="title"> <a class="featured-article--link" href="#blog_article_'+result['id']+'" data-href="'+result['url']+'">'+result['title']+'</a></h4></div></div></div></div>');

            var $fancyContainer = $('<div style="display:none"><div id="blog_article_'+result['id']+'" class="blog-popup-container"> <div class="article-title"> <h4 class="title">'+result['title']+'</h4></div> <div class="article-content">'+result['body']+'</div></div></div>');

            $($imageElementWrap).append($image);
            $($testimonial__image).append($imageElementWrap);
            $($anchor).append($testimonial__image);
            $($figure).append($anchor);
            $($blogCardImage).append($figure);
            $($testimonial__name).append($blogCardImage);
            $($column).append($testimonial__name);
            $($column).append($blogArticleOverlayContainer);
            $($column).append($fancyContainer);

            $($BlogContainer).append($column);
            $writtenBlog.parent('.section').show();
        }
        
        
      
      });
      
    } else {
      // if no results
      $('#no_results').html('<p>'+Shopify.translation.no_results+'</p>').show();
      
    }  
  }
}  
	$('a.video-data-load-more').click(function(){
      let isAllDisplayed = false;
      $(this).addClass('is-loading');
      let count = 0;
      let rows = parseInt($(this).data('rows'));
      if($('.section-video-items > [data-load-video-article] .featured-article').length){
        $('.section-video-items > [data-load-video-article] .featured-article').each(function(){
          if($(this).is(":visible")){
              count++;
              
          }else{
             
             if(rows > 0){
               isAllDisplayed = true;
               $(this).show();
               rows --;
             }
             	
          }
        });
      }
      if($('.page-details__blocks > .shopify-section.jsVideo_set').length){
          $('.page-details__blocks > .shopify-section.jsVideo_set').each(function(){
            if($(this).is(":visible")){
                count++;

            }else{

               if(rows > 0){
                 isAllDisplayed = true;
                 $(this).attr('style','display: block !important');
                 rows --;
               }

            }
          });
      }
      $(this).removeClass('is-loading');
      if(!isAllDisplayed){
        $(this).removeClass('is-loading').hide();
      }
      //$(this).removeClass('is-loading').hide();
    });
  
    $('.section-video-items [data-load-video-article] .featured-article.blog-card').each(function(){
        let img_width = $(this).width();
        $(this).height(img_width);
        
    });

    $('.shopify-section.icon-with-text-column .icon-with-text-column__column .icon-anchor').click(function(e){
        e.preventDefault();
        let href = $(this).attr('href');
        if(href.charAt(0) == "#"){
        	$('html, body').animate({
                scrollTop: $(href).offset().top - 200
            }, 1000);
        }else{
        	window.location = $(this).attr('href');
        }
    	
    });
    $("a.icon-logo-pop").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
		'overlayShow'	:	false
	});
   
//   $('.custom_tag_filter').change(function(){
//       if($(this).val() == "all"){
//       	$('.blog-card').show();
//         return false;
//       }
//       $('.blog-card.'+$(this).val()).show();
//   	  $('.blog-card:not(.'+$(this).val()+')').hide();
//   });

//   window.onload = function(){
	
//     $('script').each(function(){
//       var src = ($(this).attr('src') != undefined ? $(this).attr('src') : ""); console.log(src);
//       var init_script = $(this);
//       if(src.toLowerCase().indexOf("ontraport") >= 0){
//       	$(init_script).appendTo("#ontraport_container");
//       }
//     });
     
//   }

/** END -  CUSTOM JS CODES **/  
  
});

/*============================================================================
Slideshow arrows
==============================================================================*/


if(Shopify.theme_settings.icon_style == 'icon_solid') {
  var arrowShape = 'M95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z';
} else {
  var arrowShape = 'M95,48H9.83L41,16.86A2,2,0,0,0,38.14,14L3.59,48.58a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15l-.1.2-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31L38.14,86A2,2,0,0,0,41,86a2,2,0,0,0,0-2.83L9.83,52H95a2,2,0,0,0,0-4Z';
}
